import gql from 'graphql-tag';

export const all = gql`query getClientRates($clientId: ID!) {
    clientRates (clientId: $clientId){
        id
        name
        creationDate
        client {
            id
        }
        isMarineOnly
        rate
        franchise
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/queries/clientRate.js